<template>
  <section class="welcome-section">
    <div class="container">
      <div class="welcome-grid">
        <div class="welcome-image">
          <div class="carousel-viewport">
            <div
              class="carousel-track"
              :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
            >
              <div
                v-for="(image, index) in houseImages"
                :key="index"
                class="slide"
                :class="{ 'is-active': currentSlide === index }"
              >
                <img :src="image" alt="Luxury House" class="carousel-img" />
              </div>
            </div>
            <div class="carousel-overlay"></div>
            <div class="carousel-dots">
              <span
                v-for="(_, index) in houseImages"
                :key="index"
                class="dot"
                :class="{ active: currentSlide === index }"
                @click="currentSlide = index"
              >
                <span class="dot-inner"></span>
              </span>
            </div>
          </div>

          <div class="experience-badge-new">
            <div class="badge-content">
              <span class="years">5+</span>
              <div class="label-group">
                <span class="label-top">Years of</span>
                <span class="label-bottom">Excellence</span>
              </div>
            </div>
          </div>
        </div>

        <div class="welcome-text">
          <span class="section-tag">ABOUT US</span>
          <h2>Clients Preferred Property Hub</h2>
          <p>
            Clients Preferred Property Hub is a trusted real estate consultancy
            offering end-to-end property solutions across Tricity — Chandigarh,
            Mohali, and Panchkula.
          </p>
          <p>
            We work with carefully verified, GMADA & RERA-approved residential
            and investment projects, ensuring every client experiences complete
            transparency, legal clarity, and confidence at every step.
          </p>
          <p>
            Our mission is simple: to help homebuyers and investors make safe,
            informed, and future-ready real estate decisions.
          </p>
          <p>
            From project shortlisting and site visits to documentation support
            and possession, we provide professional guidance from start to
            finish. We believe real estate is not just about transactions — it’s
            about long-term relationships built on trust, honesty, and
            commitment.
          </p>
          <p>
            At Clients Preferred Property Hub, what we promise is what we
            deliver — on time, every time.
          </p>

          <router-link to="/about" class="btn-primary"
            >Learn More About Vipan</router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import house1 from '@/assets/images/ModernLuxuryVilla.jpeg';
import house2 from '@/assets/images/VillaBlackGate.jpeg';
import house3 from '@/assets/images/Building.png';
import house4 from '@/assets/images/SkinOne.jpeg';
import house5 from '@/assets/images/Building2.jpg';

const houseImages = [house1, house2, house3, house4, house5];
const currentSlide = ref(0);
let slideInterval = null;

onMounted(() => {
  startSlideShow();
});

const startSlideShow = () => {
  slideInterval = setInterval(() => {
    currentSlide.value = (currentSlide.value + 1) % houseImages.length;
  }, 5000);
};

onUnmounted(() => {
  if (slideInterval) clearInterval(slideInterval);
});
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.welcome-section {
  padding: 100px 0;
  background: #fff;
}
.welcome-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}
.welcome-image {
  position: relative;
  padding-bottom: 40px;
}
.carousel-viewport {
  position: relative;
  width: 100%;
  height: 580px;
  overflow: hidden;
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
  background: #111;
}
.carousel-track {
  display: flex;
  height: 100%;
  transition: transform 1.2s cubic-bezier(0.19, 1, 0.22, 1);
}
.slide {
  min-width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 6s linear;
}
.slide.is-active .carousel-img {
  transform: scale(1.1);
}
.carousel-dots {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 15px;
  z-index: 10;
}
.dot {
  width: 40px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  position: relative;
}
.dot.active .dot-inner {
  width: 100%;
  background: #fff;
  transition: width 5s linear;
  height: 100%;
  display: block;
}
.experience-badge-new {
  position: absolute;
  bottom: 10px;
  right: -59px;
  background: #b91c1c;
  color: white;
  padding: 5px 20px;
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(185, 28, 28, 0.4);
  z-index: 5;
}
.badge-content {
  display: flex;
  align-items: center;
  gap: 15px;
}
.years {
  font-size: 2.5rem;
  font-weight: 900;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  padding-right: 15px;
}
.section-tag {
  color: #b91c1c;
  font-weight: 800;
  letter-spacing: 2px;
  font-size: 0.9rem;
}
.welcome-text h2 {
  font-size: 2.5rem;
  margin: 15px 0;
  color: #111;
}
.welcome-text p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}
.btn-primary {
  display: inline-block;
  background: #b91c1c;
  color: white;
  padding: 15px 35px;
  text-decoration: none;
  font-weight: bold;
  border-radius: 4px;
  transition: transform 0.3s;
}
.btn-primary:hover {
  transform: translateY(-3px);
}

@media (max-width: 992px) {
  .welcome-grid {
    grid-template-columns: 1fr;
    gap: 60px;
  }
  .carousel-viewport {
    height: 450px;
  }
}

/* Added styling for mobile badge positioning */
@media (max-width: 768px) {
  .experience-badge-new {
    right: 50%;
    transform: translateX(50%);
    bottom: -30px;
    white-space: nowrap;
    padding: 10px 25px;
  }
}
</style>
